import React from 'react';
import { ClockCircleOutlined } from '@ant-design/icons';

// Shared countdown pill used across Conversations + Messages + Agent Testing
const countdownAnimationStyle = `
  @keyframes countdownPulse {
    0% { box-shadow: 0 0 0 0 rgba(24, 144, 255, 0.45); }
    70% { box-shadow: 0 0 0 8px rgba(24, 144, 255, 0); }
    100% { box-shadow: 0 0 0 0 rgba(24, 144, 255, 0); }
  }
`;

/**
 * Countdown pill (same visual/animation as the Conversation list item).
 *
 * Note: pass `animationKey={seconds}` if you want the pulse to restart exactly
 * when the displayed second changes (helps keep pulse + number visually in sync).
 */
const CountdownPill = ({
    seconds,
    isDarkMode,
    size = 'sm', // 'sm' | 'md'
    animationKey
}) => {
    if (!seconds || seconds <= 0) return null;

    const isMd = size === 'md';
    const height = isMd ? 28 : 18;
    const paddingX = isMd ? 10 : 6;
    const fontSize = isMd ? 13 : 12;
    const iconMargin = isMd ? 6 : 4;
    const borderRadius = Math.round(height / 2);

    return (
        <div style={{ display: 'inline-flex', alignItems: 'center' }}>
            <style dangerouslySetInnerHTML={{ __html: countdownAnimationStyle }} />
            <div
                key={animationKey}
                style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    height,
                    padding: `0 ${paddingX}px`,
                    borderRadius,
                    border: '1px solid #1890ff',
                    background: isDarkMode ? 'rgba(24, 144, 255, 0.16)' : 'rgba(24, 144, 255, 0.10)',
                    color: '#1890ff',
                    fontSize,
                    fontWeight: 600,
                    lineHeight: `${height}px`,
                    whiteSpace: 'nowrap',
                    animation: 'countdownPulse 1s ease-out infinite',
                }}
            >
                <ClockCircleOutlined style={{ marginRight: iconMargin }} />
                {seconds}s
            </div>
        </div>
    );
};

export default CountdownPill;













